export default "__VITE_ASSET__DXutNHvl__"